import { useState } from 'react';

const FAQ_ITEMS = [
  {
    q: '被窝影院是否需要注册才能观看？',
    a: '不需要。被窝影院官网完全免费开放，无需注册或登录即可直接在线观看所有影视内容。打开首页选择想看的电影或电视剧，点击播放即可享受高清流畅的观影体验。',
  },
  {
    q: '如何获取被窝影院最新地址？',
    a: '本站首页即为被窝影院最新地址，建议您收藏本页以便随时访问。您也可以下载被窝影院APP，APP端会自动更新最新地址，无需手动查找，更加方便安全。',
  },
  {
    q: '被窝影院支持哪些设备观看？',
    a: '被窝影院支持手机、平板、电脑等多种设备在线观看。网页端兼容主流浏览器，APP端支持安卓和iOS系统。高清画质自适应网络环境，确保流畅不卡顿不缓冲。',
  },
  {
    q: '为什么有些影片播放时缓冲较慢？',
    a: '播放速度主要取决于您的网络环境。建议在Wi-Fi环境下观看以获得最佳体验。被窝影院采用多线路智能调度技术，如果某条线路较慢，可以尝试刷新页面切换播放线路。',
  },
  {
    q: '被窝影院的资源多久更新一次？',
    a: '被窝影院每日滚动更新影视资源。热门电影和电视剧通常在院线上映或平台首播后第一时间上线。您可以关注首页热门话题和热播排行区域，第一时间发现新上线的精彩内容。',
  },
  {
    q: '被窝影院APP如何下载？',
    a: '请访问首页「APP下载」区域，选择安卓或iOS版本进行下载安装。被窝影院APP提供缓存下载功能，支持离线观看。如遇安装问题，请通过首页联系我们区域反馈。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于被窝影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all ${
                  openIndex === i
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed pt-0 border-t border-transparent">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}